import apiUrl, { axios } from "../../../../../utils/settings";
import { getToken, getTokenHeader } from "../../../../../screen/auth/action";
import { annualTripDetailsUrl } from "../urls";
import {
  sendBeneficiaryOtpUrl,
  verifyBeneficiaryOtpUrl,
} from "../../../../Beneficiary/Gap/APIs/url";


export const getAnnualTripDetails = async (manufacturer_id, company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${annualTripDetailsUrl()}?manufacturer_id=${manufacturer_id}&company_esi_id=${company_esi_id}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};



// TO REMOVE OTP ACTIONS
export const sendOTPAction = async (phoneNumber, resend = false) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        sendBeneficiaryOtpUrl(),
        {
          phone_number: phoneNumber,
          resend_otp: resend,
          privacy_policy_accept_status: true,
          flow: "voucher",
        },
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const verifyOTPAction = async (phoneNumber, otp) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        verifyBeneficiaryOtpUrl(),
        { phone_number: phoneNumber, otp },
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
